<template>
  <div class="featured-book-container top-padding">
    <div class='featured-book-listing popluar-clips-listing combine-section'>
      <!-- <h2 v-if="bookList.length == 1" class='robot_medium text-capitalize pl-10'>Featured {{ trans("book.singular") }} & {{ trans("clip.multiple") }} </h2>
      <h2 v-else-if="bookList.length > 1" class='robot_medium text-capitalize pl-10'>Featured {{ trans("book.multiple") }} & {{ trans("clip.multiple") }}</h2> -->
      <h2 class='robot_medium text-capitalize pl-10'>Featured {{ trans("book.multiple") }}</h2>
      <featured-book 
        :book-list="bookList" 
        :page="page" 
        :my-book-list="myBookList" 
        :token="token" 
        :current_user="current_user" 
        :is_admin="is_admin"
        :type="type"
        :is_combine="true"
        >
      </featured-book>
      <div class="test"></div>
      <!-- <div class="combine-section"> -->
        <h2 v-if="bookList.length < 3" class='robot_medium text-capitalize pl-10 show-in-top'>Featured {{ trans("clip.multiple") }}</h2>
        <popular-clip 
          :clip-list="clipList" 
          :page="page" 
          :book-list="myBookList" 
          :token="token"
          :current_user="current_user"
          :is_admin="is_admin"
          :is_combine="true"
          :is_show_section_thumbnail="bookList.length > 2 ? true : false"
        >
        </popular-clip>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["myBookList", "clipList", "current_user", "bookList", "page", "token", "is_admin", "type"],
  data() {
    return {
    };
  },
  components: {
    "featured-book": require("../components/Featured.vue"),
    "popular-clip": require("../components/PopularClip.vue")
  },
  methods: {
    
  }
};
</script>
